export default __webpack_public_path__ + "static/media/pantry1-afterH-768w.3acec722.png";